import React from 'react';
import { useState } from 'react';

import styles from './AddTodo.module.css';
import EnterIcon from './commons/EnterIcon';

function InputText(props) {
  const [tempTitle, setTempTitle] = useState('');
  const typeText = (e) => {
    setTempTitle(e.target.value);
  };

  const onConfirm = () => {
    props.onConfirm(tempTitle);
    setTempTitle('');
  };

  const _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  return (
    <div
      className="box-shadow"
      style={{ marginBottom: '20px', padding: '14px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: '1 1 0' }}>
          <input
            style={{ color: '#9b9b9b' }}
            type="text"
            onChange={typeText}
            value={tempTitle}
            className={styles.form__field}
            placeholder="Name"
            required
            onKeyDown={_handleKeyDown}
          ></input>
        </div>
        <div style={{ marginLeft: '12px' }}>
          <EnterIcon />
        </div>
      </div>
    </div>
  );
}

export default InputText;
